<template>
  <deliverysetupDetails></deliverysetupDetails>
</template>

<script>
import deliverysetupDetails from "@/components/MasterSetup/deliverysetup/deliverysetupDetails";
export default {
    components: {
        deliverysetupDetails
    }
};
</script>